import actionTypes from './actionTypes'

const MatchingPairsCtActions = {
	saveSettings() {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_SAVE_SETTINGS,
		}
	},
	toggleHeader() {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_TOGGLE_HEADER,
		}
	},
	deletePair(id) {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_DELETE_PAIR,
			id,
		}
	},
	showModal() {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_SHOW_MODAL,
		}
	},
	hideModal() {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_HIDE_MODAL,
		}
	},
	instructionsChange(value) {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_INSTRUCTIONS_CHANGE,
			value,
		}
	},
	instructionsBlur() {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_INSTRUCTIONS_BLUR,
		}
	},
	cancel() {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_CANCEL_MP,
		}
	},
	save() {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_SAVE_ACTIVITY,
		}
	},
	openPreview() {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_OPEN_PREVIEW,
		}
	},
	openSettings() {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_OPEN_SETTINGS,
		}
	},
	addPair() {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_ADD_PAIR,
		}
	},
	addTimer() {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_ADD_TIMER,
		}
	},
	editTimer() {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_EDIT_TIMER,
		}
	},
	deleteTimer() {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_DELETE_TIMER,
		}
	},
	saveTimer(value) {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_SAVE_TIMER,
			value,
		}
	},
	cancelTimer() {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_CANCEL_TIMER,
		}
	},
	pairChangeText(value, cardName, clientId) {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_PAIR_CHANGE_TEXT,
			value,
			cardName,
			clientId,
		}
	},
	pairAddAnImage(cardName, clientId) {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_PAIR_ADD_AN_IMAGE,
			cardName,
			clientId,
		}
	},
	pairDiscardContent(cardName, clientId) {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_PAIR_DISCARD_CONTENT,
			cardName,
			clientId,
		}
	},
	cardNewText(cardName, clientId) {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_CARD_NEW_TEXT,
			cardName,
			clientId,
		}
	},
	pairImagePickerClose() {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_PAIR_IMAGE_PICKER_CLOSE,
		}
	},
	pairImagePicked(allowedTypes, files, cardName, force) {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_PAIR_IMAGE_PICKED,
			allowedTypes,
			files,
			cardName,
			force,
		}
	},
	pairImagePickError(messageError, cardName, clientId) {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_PAIR_IMAGE_PICK_ERROR,
			message: messageError,
			cardName,
			clientId,

		}
	},
	pairSave(clientId) {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_PAIR_SAVE,
			clientId,
		}
	},
	pairAddAnother() {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_PAIR_ADD_ANOTHER,
		}
	},
	editPair(dataPair) {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_EDIT_PAIR,
			dataPair,
		}
	},
	closeEditPair() {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_CLOSE_EDIT_PAIR,
		}
	},
	pairDeleteReject() {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_PAIR_DELETE_REJECTED,
		}
	},
	pairDeleteConfirm(id) {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_PAIR_DELETE_CONFIRMED,
			id,
		}
	},
	cancelConfirm() {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_CANCEL_MP_CONFIRMED,
		}
	},
	cancelReject() {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_CANCEL_MP_REJECTED,
		}
	},
	uploaderValidateSuccess(clientId, uploadId, cardName) {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_UPLOADER_VALIDATE_SUCCESS,
			clientId,
			uploadId,
			cardName,
		}
	},
	closePreview() {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_CLOSE_PREVIEW,
		}
	},
	pairChangeImageMatrix(value, cardName, clientId) {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_PAIR_CHANGE_IMAGE_MATRIX,
			value,
			cardName,
			clientId,
		}
	},
	pairImageLoad(width, height, cardName, clientId) {
		return {
			type: actionTypes.MATCHING_PAIRS_CT_PAIR_IMAGE_LOAD,
			width,
			height,
			cardName,
			clientId,
		}
	},
}

export default MatchingPairsCtActions
